import { print } from "graphql";
import { BaseAPI } from "@/api/base.api";
import { AxiosObservable } from "axios-observable/dist/axios-observable.interface";
import { map } from "rxjs/operators";
import {
  VUE_APP_FINANCEIRO_API_URL,
  VUE_APP_NAME,
  API_URL_SERVICE,
} from "@/commons/config";
// const show = require("@/query/newNegociation/Negociation.graphql");
// const listSefazRevenue = require("@/query/newNegociation/ListSefazRevenue.graphql");
// const listSefazProduct = require("@/query/newNegociation/ListSefazProduct.graphql");

const token = localStorage.getItem(`${VUE_APP_NAME}-transportadora-auth`) || "";
const apiCentralServicos = `${API_URL_SERVICE}/api`;

export class NewNegociationAPI extends BaseAPI<any> {
  constructor() {
    super();
    this.apiUrl = `${VUE_APP_FINANCEIRO_API_URL}/api/centralServicos`;
    this.graphqlUrl = `${VUE_APP_FINANCEIRO_API_URL}/graphql`;
  }

  public listSefazReceita(cpfCnpj: String): AxiosObservable<any> {
    return this.axios.post(`${this.apiUrl}/sefazReceitaListByContribuinte`, {
      cpfCnpj: cpfCnpj,
    });
  }

  public listSefazProduto(
    cpfCnpj: String,
    sefazReceitaId: number
  ): AxiosObservable<any> {
    return this.axios.post(`${this.apiUrl}/sefazProdutoListByContribuite`, {
      cpfCnpj: cpfCnpj,
      sefazReceitaId: sefazReceitaId,
    });
  }
  public listReceitasAptasNegociacao(body: {
    cpfCnpj: String;
    idSefazProduto: number;
    naoAptas: boolean;
    ascendingSort: boolean;
    page: number;
    size: number;
    sort: String;
  }): AxiosObservable<any> {
    return this.axios.post(
      `${this.apiUrl}/receitasAptasNegociacaoCpfCnpj`,
      body
    );
  }
  public simularNegociacao(body: {
    cpfCnpj: string;
    ids: [];
    parcelas: number;
    dataVencimento: string;
    dataNegociacao: string;
  }): AxiosObservable<any> {
    return this.axios.post(`${this.apiUrl}/receitaSimulacao`, body);
  }

  public saveNegociacao(body: {
    cpfCnpj: string;
    ids: [];
    divided: number;
    date: string;
    dateNegotiation: string;
    observacao: string;
  }): AxiosObservable<any> {
    return this.axios.post(`${this.apiUrl}/negociacaoSave`, body);
  }
  public aceitarTermosAndAutosNotificar(body: {
    numeroAitp: [];
    cpfCnpj: string;
    numOrdem: number;
    lgpd: boolean;
    recapcha: string;
  }): AxiosObservable<any> {
    return this.axios.post(
      `${apiCentralServicos}/pdf/sit/relatorio-frota/auto-infracao/atualiza-notificar`,
      body
    );
  }

  public aceitarTermos(body: {
    cpfCnpj: string;
    numOrdem: number;
    lgpd: boolean;
    recapcha: string;
  }): AxiosObservable<any> {
    return this.axios.post(
      `${apiCentralServicos}/transportadora/aceiteTermo`,
      body
    );
  }

  public simularQuitacao(
    cpfCnpj: string,
    idReceita: number
  ): AxiosObservable<any> {
    return this.axios.post(
      `${this.apiUrl}/simularQuitacaoParcelamento/${idReceita}`,
      {
        cpfCnpj,
      }
    );
  }
  public salvarQuitacao(
    cpfCnpj: string,
    idReceita: number
  ): AxiosObservable<any> {
    return this.axios.post(
      `${this.apiUrl}/saveQuitacaoParcelamento/${idReceita}`,
      {
        cpfCnpj,
      }
    );
  }

  public listParcelamentos(
    cpfCnpj: string,
    paginacao: object
  ): AxiosObservable<any> {
    return this.axios.post(`${this.apiUrl}/listParcelamentoPorCnpj`, {
      cpfCnpj,
      ...paginacao,
    });
  }

  public listParcelas(cpfCnpj: string, idGrupo: string): AxiosObservable<any> {
    return this.axios.post(
      `${this.apiUrl}/parcelamentoPorGrupoOnlyPreParcelado`,
      {
        cpfCnpj,
        id: idGrupo,
      }
    );
  }
  public baixarDae(
    cpfCnpj: string,
    ids: [],
    date: string
  ): AxiosObservable<any> {
    return this.axios.post(
      `${this.apiUrl}/dae-gerar`,
      {
        cpfCnpj,
        ids,
        date,
      },
      { responseType: "blob" }
    );
  }

  public historicoNegociacao(cnpj: string, receitas: []): AxiosObservable<any> {
    return this.axios.post(
      `${apiCentralServicos}/financeiro/aceiteParcelamento`,
      {
        cnpj,
        receitas,
      }
    );
  }

  public countSefazProdutos(body: {
    cpfCnpj: String;
    idSefazProduto: number;
    naoAptas: boolean;
    ascendingSort: boolean;
    page: number;
    size: number;
    sort: String;
  }): AxiosObservable<any> {
    return this.axios.post(`${this.apiUrl}/dashboard-receita`, body);
  }

  public detailsReceitaQuitacao(
    idReceitaGrupo: number,
    cpfCnpj: String
  ): AxiosObservable<any> {
    return this.axios.post(
      `${this.apiUrl}/consultaReceitaQuitacaoGrupo/${idReceitaGrupo}`,
      { cpfCnpj }
    );
  }

  public aceitarTermosParcelamento(
    cnpj: String,
    numOrdem: String,
    parcelamento: Boolean,
    recaptcha: String
  ): AxiosObservable<any> {
    return this.axios.post(
      `${apiCentralServicos}/financeiro/aceiteParcelamentoHistorico`,
      { cnpj, numOrdem, parcelamento, recaptcha }
    );
  }

  public checkAceiteTermosParcelamento(
    cnpj: String,
    numOrdem: String,
    parcelamento: Boolean
  ): AxiosObservable<any> {
    return this.axios.post(
      `${apiCentralServicos}/financeiro/verificaParcelamento`,
      { cnpj, numOrdem, parcelamento }
    );
  }
}
